import { EmptyState } from '@/components/custom/empty-state';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { AiOutlineTrophy } from 'react-icons/ai';
import usePermission from '@/hooks/usePermission';
import moment from 'moment';
import { useSession } from '@/hooks/useSession';

export function UsageTable({ filters, tableData }) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [filteredData, setFilteredData] = useState(tableData);
  const { session } = useSession();
  const token = session?.user?.authToken;

  const handleDownload = () => {
    setIsDownloading(true);

    let url = `${process.env.REACT_APP_DEV_URL}/reports/usage/export?start_date=${filters.values['start-date']}&end_date=${filters.values['end-date']}`;

    if (filters.values.regional) {
      url += `&regional_id=${filters.values.regional}`;
    }

    fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao baixar o relatório');
        }
        return response.blob();
      })
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `relatorio_de_uso_${moment().format('YYYYMMDDHHmmss')}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        toast.success('Relatório baixado com sucesso!');
      })
      .catch(error => {
        console.error('Erro no download:', error);
        toast.error('Erro ao baixar o relatório');
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  useEffect(() => {
    if (filters.values.searchTerm.length > 0) {
      const filtered = tableData?.filter(item => item?.['feature_label_pt']?.toLowerCase().includes(filters.values.searchTerm.toLowerCase()));
      setFilteredData(filtered);
    } else {
      setFilteredData(tableData);
    }
  }, [filters.values['searchTerm']]);

  return (
    <div className="report-widget">
      <div className="report-widget__header">
        <h3 className="report-widget__title">Ranking por uso das funcionalidades</h3>
        <div className="report-widget__filter">
          {usePermission('Download de relatórios', 'Relatórios') && (
            <button
              className="btn btn--outline"
              type="button"
              onClick={handleDownload}
            >
              {isDownloading ? 'Baixando...' : 'Download do relatório'}
            </button>
          )}
        </div>
      </div>

      <div className="report-widget__filter">
        <input
          className="report-form__control report-form__control--md"
          aria-label="Pesquisar"
          placeholder="Pesquisar"
          type="search"
          name="search"
          id="search"
          onChange={e => filters.setFieldValue('searchTerm', e.target.value)}
          disabled={tableData?.length === 0 && filters.values.searchTerm === ''}
          z
        />
      </div>

      <div className="report-widget__body">
        {filteredData?.length === 0 ? (
          <EmptyState
            title="Nenhum dado disponível"
            type="data"
            text="Não há dados a serem exibidos."
            className="my-10"
          />
        ) : (
          <table
            className="round-dg round-dg--light"
            style={{ minWidth: '720px' }}
          >
            <thead className="round-dg__header">
              <tr className="round-dg__row">
                <th
                  className="round-dg__cell-header round-dg__cell-header--sm"
                  style={{ width: '80px' }}
                >
                  Posição
                </th>
                <th
                  className="round-dg__cell-header round-dg__cell-header--sm"
                  style={{ width: '50px' }}
                ></th>
                <th className="round-dg__cell-header round-dg__cell-header--sm">Funcionalidade</th>
                <th className="round-dg__cell-header round-dg__cell-header--sm u-text text-right">Acessos</th>
                <th className="round-dg__cell-header round-dg__cell-header--sm u-text text-right">Percentual</th>
              </tr>
            </thead>

            <tbody className="round-dg__body">
              {filteredData?.length > 0 &&
                filteredData?.map((item, i) => (
                  <tr
                    key={item.id}
                    className={`round-dg__row`}
                  >
                    <td className="round-dg__cell round-dg__cell--sm u-text-right">{i + 1 < 10 ? `0${i + 1}` : i + 1}</td>
                    <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
                      {i === 0 && <AiOutlineTrophy className="card__icon card__icon--golden mr-3" />}
                      {i === 1 && <AiOutlineTrophy className="card__icon card__icon--silver mr-3" />}
                      {i === 2 && <AiOutlineTrophy className="card__icon card__icon--bronze mr-3" />}
                    </th>
                    <th className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">{item?.['feature_label_pt']}</th>
                    <td className="round-dg__cell round-dg__cell--sm u-text-right">{item?.accesses}</td>
                    <td className="round-dg__cell round-dg__cell--sm u-text-right">{item?.['percent_of_total_route_logs']}%</td>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
